import { render, staticRenderFns } from "./operateRecord.vue?vue&type=template&id=3cb81faf&scoped=true"
import script from "./operateRecord.vue?vue&type=script&lang=js"
export * from "./operateRecord.vue?vue&type=script&lang=js"
import style0 from "./operateRecord.vue?vue&type=style&index=0&id=3cb81faf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb81faf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb81faf')) {
      api.createRecord('3cb81faf', component.options)
    } else {
      api.reload('3cb81faf', component.options)
    }
    module.hot.accept("./operateRecord.vue?vue&type=template&id=3cb81faf&scoped=true", function () {
      api.rerender('3cb81faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/operateRecord.vue"
export default component.exports